import { HttpInterceptors } from "./http.interceptor";

export class SchedulingService extends HttpInterceptors {
	async weekDays (payload) {
		const response = await this.axios.get("scheduling/weekDays", { params: { payload }});
		return response.data;
	}

	async scheduling (payload) {
		const response = await this.axios.get("scheduling/scheduling", { params: { payload }});
		return response.data;
	}

	async createScheduling (payload) {
		const response = await this.axios.post("scheduling/createScheduling", payload);
		return response.data;
	}

	async updateScheduling (payload) {
		const response = await this.axios.patch("scheduling/updateScheduling", payload);
		return response.data;
	}

	async deleteScheduling (payload) {
		const response = await this.axios.patch("scheduling/deleteScheduling", payload);
		return response.data;
	}

	async actionScheduling (payload) {
		const response = await this.axios.patch("scheduling/actionScheduling", payload);
		return response.data;
	}

}
